define('modules/editor/views/editors/seo_custom_meta_item',['require','exports','module','base/itemview','ldsh!../../templates/editors/seo_custom_meta_item'],function(require, exports, module){
  "use strict";
  var View = require("base/itemview");

  module.exports = View.extend({
    template: require("ldsh!../../templates/editors/seo_custom_meta_item"),
    events: {
      "click .js-remove": "removeItem",
      "change .js-meta-name": "updateModel",
      "change .js-meta-value": "updateModel"
    },
    updateModel: function(e) {
      e.preventDefault();
      var name = this.$(".js-meta-name").val().trim(),
          value = this.$(".js-meta-value").val().trim();
      this.model.set({
        name: name,
        value: value
      });
    },
    removeItem: function(e){
      e.preventDefault();
      this.trigger("item:remove");
    },
  });
});

